import React from 'react';

import {Helmet} from 'views/module';

import EditJob from 'views/scenes/career/job_create/EditJob';

const JobCreate = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <EditJob
      />
    </>
  );
};

export default JobCreate;
